/* eslint-disable ember/no-classic-classes */

// Convert once ember-source is 3.16+
import { fullTimeRange } from 'client-portal/components/shared/date-range-picker';
import { loadUntilVisibleBillingRecords } from 'client-portal/utils/billing/visible-billing-records';
import { service } from '@ember/service';
import ENV from 'client-portal/config/environment';
import InfinityModel from 'ember-infinity/lib/infinity-model';
import Route from '@ember/routing/route';

function visibleInvoiceCount(route, itemStatus) {
  if (route.thisType !== 'invoice') {
    return;
  }

  let client = route.modelFor('site.billing');

  if (itemStatus === 'due' || itemStatus === 'late') {
    return client?.visibleUnpaidInvoices?.length;
  }

  return client?.clientBillingOverview?.visibleInvoicesCount;
}

const ExtendedInfinityModel = InfinityModel.extend({
  buildParams() {
    let params = this._super(...arguments);
    params.page = { before: this.before, size: ENV.maxPageSize };
    return params;
  },

  afterInfinityModel(model) {
    this.set('canLoadMore', model.length >= ENV.maxPageSize);
    this.set('before', model.at(-1)?.cursorId);
  },
});

export default Route.extend({
  queryParams: {
    timeRange: { refreshModel: true },
  },

  infinity: service(),
  fastboot: service(),

  async model({ timeRange, itemStatus }) {
    if (this.fastboot.isFastBoot) {
      return [];
    }

    let infinityModel = await this.infinity.model(
      'polymorphic/billing-item',
      {
        filter: {
          thisType: this.thisType,
          timeRange: timeRange ? fullTimeRange(timeRange) : null,
          itemStatus: itemStatus || undefined,
        },
        perPageParam: null,
        pageParam: null,
      },
      ExtendedInfinityModel
    );

    return loadUntilVisibleBillingRecords(infinityModel, {
      infinity: this.infinity,
      visibleCount: visibleInvoiceCount(this, itemStatus),
    });
  },

  setupController(controller) {
    this._super(...arguments);

    controller.set('client', this.modelFor('site.billing'));
  },

  resetController(controller, isExiting, _transition) {
    this._super(...arguments);

    if (isExiting) {
      controller.set('client', undefined);
      controller.set('itemStatus', undefined);
    }
  },
});
